import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { Box, CircularProgress } from '@mui/material';

const SatisfactionBarChart = ({ data, loading = false, height = '250px' }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const chartDom = chartRef.current;
    if (!chartDom) return;

    // 清空並銷毀舊實例
    let chart = echarts.getInstanceByDom(chartDom);
    if (chart) {
      chart.dispose();
    }
    chartDom.innerHTML = '';

    chart = echarts.init(chartDom, null, { renderer: 'svg' });
    chartInstance.current = chart;

    if (loading || !data || data.length === 0) {
      return;
    }

    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'none' }
      },
      grid: {
        top: 30,
        left: 60,
        right: 20,
        bottom: 30,
        containLabel: false
      },
      xAxis: {
        type: 'category',
        data: ['< 1 Min', '1-10 Mins', '10-60 Mins', '> 60 Mins'],
        axisLabel: { fontSize: 10, color: '#A0AEC0' },
        axisLine: { lineStyle: { color: '#E2E8F0' } },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 10,
          color: '#A0AEC0',
          formatter: (value) => value >= 1000 ? (value / 1000) + 'k' : value
        },
        splitLine: { lineStyle: { type: 'dashed', color: '#EDF2F7' } }
      },
      series: [
        {
          data: data.map(item => item[1]),
          type: 'bar',
          barWidth: '35%',
          itemStyle: {
            color: '#4C6EF5',
            borderRadius: [0, 0, 0, 0]
          }
        }
      ]
    };

    chart.setOption(option);
    const handleResize = () => chart.resize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      chart.dispose();
    };
  }, [data, loading]);

  return (
    <Box sx={{ width: '100%', height, position: 'relative' }}>
      <Box
        ref={chartRef}
        sx={{
          width: '100%', height: '100%',
          opacity: loading ? 0 : 1,
          transition: 'opacity 0.3s'
        }}
      />
    </Box>
  );
};

export default SatisfactionBarChart;